"use strict";

console.log('TMG::main', window._getTimeSinceStart());

jQuery.noConflict();
(function($){

	var $doc = $(document);
	var $window = $(window);
	var isTouchDevice = false;

	var windowWidth = $window.width();
	var windowHeight = $window.height();

	// Match values to _vars.scss
	var smallBreakpoint = 680;//570;
	var mediumBreakpoint = 1080;
	var largeBreakpoint = 1440;
	var extraLargeBreakpoint = 1920;
	var baseSpacingUnit = 20;
	var doubleSpacing = baseSpacingUnit * 2;
	var tripleSpacing = baseSpacingUnit * 3;
	var halfSpacing = baseSpacingUnit * 0.5;
	var quarterSpacing = baseSpacingUnit * 0.25;

	var isLarge;
	var isExtraLarge;
	var isMedium;
	var isSmall;
	var isSmallAndMedium;

	var scrollers = [];

	var resizeTasks = [];
	var loadTasks = [];
	var scrollTasks = [];
	var scrollDirection = "";

	if ('ontouchstart' in document.documentElement) {
		isTouchDevice = true;
	}

	/***************************
	 *
	 *	FOUND_VIA COOKIE
	 *
	 ***************************/

	if ( Utils.getURLParameter('found_via') !== "" ) {
		Cookies.set('found_via', Utils.getURLParameter('found_via'), { expires: 2 });
	}
	else if ( Utils.getURLParameter('udid') !== "" ) {
		Cookies.set('found_via', Utils.getURLParameter('udid'), { expires: 2 });
	}

	if ( Utils.getURLParameter('campaign') !== "" ) {
		Cookies.set('campaign', Utils.getURLParameter('campaign'), { expires: 2 });
	}


	/***************************
	 *
	 *	ANIMATED SCROLLTO
	 *
	 ***************************/

	function scrollTo(element, offset, duration) {
		var $target = $(element);
		if (typeof offset === 'undefined') {
			offset = $('.header').outerHeight() + 40;
		}
		if (typeof duration === 'undefined') {
			duration = 800;
		}

		if ($target.length) {
			var targetTop = $target.offset().top - offset;
			$('html,body').animate({ scrollTop: targetTop }, duration);
		}
	}


	/***************************
	 *
	 *	GRAVITY FORMS
	 *
	 ***************************/


	function gravityFormsCustomSelects($form) {
		//var $selects = $form.find('.gfield_select, .gfield_date_dropdown_day select, .gfield_date_dropdown_month select, .gfield_date_dropdown_year select, .ginput_complex select, .gfield_time_ampm select').not('[multiple]').not('.chzn-done').not('.no-customSelect');
		var $selects = $form.find('.gfield select').not('[multiple]').not('.chzn-done').not('.no-customSelect');
		if ( $selects.length ) {
			$selects.niceSelect();
			$selects.on('change', function(){
				var $this = $(this);
				$this.niceSelect('update');
				$this.next('.nice-select').toggleClass('has-value', $this.val() !== '');
			}).trigger('change');
		}
	}

	$doc.bind('gform_post_render', function(e, formId, currentFormPage) {

		var $form = $('#gform_' + formId);

		$form.attr('novalidate', 'novalidate');

		if ( $form.find('.found_via-field').length ) {
			var foundViaCookie = Cookies.get('found_via');
			var udidCookie = Cookies.get('udid');
			if ( foundViaCookie && foundViaCookie !== '' ) {
				$form.find('.found_via-field .ginput_container > input').val(foundViaCookie);
			}
			else if ( udidCookie && udidCookie !== '' ) {
				$form.find('.found_via-field .ginput_container > input').val( udidCookie );
			}
		}
		if ( $form.find('.campaign-field').length ) {
			var campaignCookie = Cookies.get('campaign');
			if ( campaignCookie && campaignCookie !== '' ) {
				$form.find('.campaign-field .ginput_container > input').val(campaignCookie);
			}
		}

		if ($form.hasClass('autocomplete-off')) {
			$form.attr('autocomplete', 'off');
			// above is now ignored
			$form.find('.gfield:not(.gform_validation_container)').each(function(){
				$(this).find('input, textarea').prop('autocomplete', 'foobar');
			});
		}


		$form.find('.gform_footer button, .gform_page_footer button').each(function(){
			var $btn = $(this);
			var label = $btn.html();
			if (!$btn.find('> span').length) {
				var $ico = $btn.find('.ico');
				if ($ico.length) {
					$ico.detach();
				}
				var btnClass = ( $btn.hasClass('gform_next_button') || $btn.hasClass('gform_previous_button') ) ? 'btn--secondary' : 'btn--primary'
				$btn.html('<span>' + label + '</span>').addClass('btn ' + btnClass + ' btn--wide');
				if ($ico.length) {
					$btn.append($ico);
				}
				else if ( $form.hasClass('action-button') && btnClass === "btn--primary" ) {
					$btn.removeClass('btn--wide').addClass('btn--action');
				}
			}
		});


		var $disabledFields = $form.find('.gfield.disabled');
		if ($disabledFields.length) {
			$disabledFields.each(function(){
				var $input = $(this).find('input, select, textarea');
				$input.addClass('disabled');
			});
		}

		gravityFormsCustomSelects($form);

		$form.find('input[value="gf_other_choice"]').each(function(){
			var $otherChoice = $(this);
			var inputName = $otherChoice.attr('name');
			$otherChoice.parent().addClass('other-choice');
			$('input[name="' + inputName + '"]').on('change', function(e){
				var currentValue = $('input[name="' + inputName + '"]:checked').attr('value');
				if ( currentValue === 'gf_other_choice' ) {
					$otherChoice.parent().addClass( 'checked' );
				}
				else {
					$otherChoice.parent().removeClass( 'checked' );
				}
			});
		});

		$form.find('.gfield_radio, .gfield_checkbox').each(function(){
			$(this).closest('.gfield').addClass('gfield_has_choices');
		});

		$form.on('submit', function(e){
			$(this).addClass('waiting').find('input:submit,button:submit').addClass('disabled', 'disabled');
		});

		$form.removeClass('waiting').find('input:submit,button:submit').removeClass('disabled');

		if ($form.find('.validation_error').length && $form.closest('.section').length) {
			scrollTo($form, 150);
		}

		$('.gfield_error input:not(:radio):not(:checkbox), .gfield_error textarea').on('keyup', function(){
			$(this).closest('.gfield').addClass('gfield_changed');
		});

		if (window.gform) {
			window.gform.addAction('gform_post_conditional_logic_field_action', function (formId, action, targetId, defaultValues, isInit) {
				setTimeout(function(){
					window.onWindowResize();
				}, 100);
			});
		}

		if (typeof window.updateScrollers === 'function') {
			window.updateScrollers();
		}

		var $addressFieldError = $form.find('#field_' + formId + '_45.gfield--type-address.gfield_error');
		if ( $addressFieldError.length ) {
			var addressFieldErrorMessage = $('#validation_message_' + formId + '_45').html();
			if ( addressFieldErrorMessage.indexOf('Please call us') !== -1 ) {
				// postcode is not serviceable, show the popup
				var $workAreaAlert = $('#work_area_alert');
				if ( !$workAreaAlert.length ) {
					var workAreaPostcode = $form.find('#input_' + formId + '_45_5').val();
					$workAreaAlert = $(`<div class="modal" id="work_area_alert" aria-hidden="true"><div class="modal__bg"></div><div class="modal__inner"><button type="button" class="trans-btn modal__close" title="Close"><i class="ico ico--close"></i></button><div class="modal__body"><div style="padding: 30px"><h3>So sorry</h3><p>We currently don't have a technician to help in postcode ${workAreaPostcode}. Please call us on <a href="tel:131149">13 11 49</a> for further help.</p></div></div></div></div>`)
					$('body').append( $workAreaAlert );
				}

				setTimeout(function(){
					$('html').addClass('modal-open');
					$workAreaAlert.addClass('modal--open').attr('aria-hidden', 'false');
				}, 100);

				setTimeout(function(){
					window.customInitGfGeo();
				}, 1000);

			}
		}

	});

	$doc.bind('gform_confirmation_loaded', function(e, formId) {
		if (typeof window.updateScrollers === 'function') {
			window.updateScrollers();
		}
		scrollTo( $('#gform_confirmation_wrapper_' + formId) , 150);
	});



	$doc.ready(function(){

		var $body = $('body');
		var $html = $('html');
		var $htmlBody = $('html, body');

		if (isTouchDevice) {
			$html.addClass('is-touch');
		}

		function responsiveSizes() {
			windowWidth = $window.width();
			windowHeight = $window.height();
			isSmall = (windowWidth <= smallBreakpoint);
			isMedium = (windowWidth > smallBreakpoint && windowWidth <= mediumBreakpoint);
			isLarge = (windowWidth > mediumBreakpoint);
			isExtraLarge = (windowWidth > largeBreakpoint);
			isSmallAndMedium = (isSmall || isMedium);
		}
		responsiveSizes();


		function transitionToNewPage( url ) {
			/*
			$html.addClass('loading');
			setTimeout(function(){
				window.location.href = url;
			}, 300);
			*/

			window.location.href = url;
		}

		/***************************
		 *
		 *	SVG
		 *
		 ***************************/
		loadTasks.push(function(){
			// TODO: Should just be if ! IE
			if ( !isLarge ) {
				$('svg').removeAttr('width').removeAttr('height');
			}
		});


		/***************************
		 *
		 *	EXTERNAL LINKS
		 *
		 ***************************/

		$('a[target="_blank"]').attr('rel', 'noopener');


		/***************************
		 *
		 *	LAZY LOADING
		 *
		 ***************************/

		// will handle lazy loading fallback AND lazy-bg
		var lazyLoader = new LazyLoad({
			callback_loaded: function(element) {
				$.fn.matchHeight._update();
				$window.trigger('resize');
			}
		});



		/***************************
		 *
		 *	MASTHEAD
		 *
		 ***************************/

		var $minimalMasthead = $('.masthead.masthead-style--minimal');
		var $trustBadgesMasthead = $('.masthead.masthead-style--trust-badges');

		function responsiveMasthead() {
			if ( $minimalMasthead.length ) {
				document.body.style.setProperty('--masthead-height', $minimalMasthead.find('.masthead__content').outerHeight() + 'px')
			}
			if ( $trustBadgesMasthead.length ) {
				$trustBadgesMasthead.each(function(){
					var $masthead = $(this);
					var offset = $masthead.find('.masthead__content').offset().left - $masthead.offset().left;
					if ( windowWidth >= 1200 ) {
						$masthead.find('.trust-badges').css('left', offset + 'px');
						$masthead.find('.reviews-snapshot').css('right', offset + 'px');
					}
					else {
						$masthead.find('.trust-badges').css('left', '');
						$masthead.find('.reviews-snapshot').css('right', '');
					}
				});
			}
		}

		resizeTasks.push(responsiveMasthead);


		/***************************
		 *
		 *	NICE SELECT
		 *
		 ***************************/

		var $selects = $('select').not('[multiple]').not('.chzn-done').not('.no-customSelect');
		if ( $selects.length ) {
			$selects.each(function(){
				var $select = $(this);
				if ( !$select.closest('.gfield').length ) {
					$selects.niceSelect();
					$selects.on('change', function(){
						var $this = $(this);
						$this.next('.nice-select').toggleClass('has-value', $this.val() !== '');
					}).trigger('change');
				}
			});
		}


		/***************************
		 *
		 *	ISCROLL
		 *
		 ***************************/

		var $scrollers = $('.scroller');

		function initScrollers($scroller) {
			if (typeof $scroller !== 'undefined' && $scroller.length) {
				var scroller = $scroller.data('scroller');
				if (typeof scroller !== 'undefined') {
					setTimeout(function () {
						scroller.refresh();
						if (scroller.scrollerHeight > scroller.wrapperHeight) {
							$scroller.addClass('scroll-enabled');
						}
						else {
							$scroller.removeClass('scroll-enabled');
						}
					}, 10);
				}
				else {
					var iScrollOptions = {
						scrollX: false,
						scrollY: true,
						scrollbars: true,
						interactiveScrollbars: true,
						mouseWheel: true,
						probeType: 2,
						bindToWrapper: true,
						bounce: false
					};
					if (isTouchDevice) {
						iScrollOptions.interactiveScrollbars = false;
						iScrollOptions.mouseWheel = false;
						//iScrollOptions.click = false;
						iScrollOptions.click = true;
						//iScrollOptions.tap = true;
						iScrollOptions.preventDefaultException = {
							className: /(^|\s)pac-container(\s|$)/,
							tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|A|LABEL)$/
						};
					}

					if ($scroller.hasClass('scroller--horizontal')) {
						iScrollOptions.scrollY = false;
						iScrollOptions.scrollX = true;
						iScrollOptions.mouseWheel = false;
					}

					scroller = new IScroll($scroller.get(0), iScrollOptions);

					if (scroller.scrollerHeight > scroller.wrapperHeight || scroller.scrollerWidth > scroller.wrapperWidth) {
						$scroller.addClass('scroll-enabled');
					}
					else {
						$scroller.removeClass('scroll-enabled');
					}

					scrollers.push(scroller);

					$scroller.data('scroller', scroller);
				}
			}
		}

		if ($scrollers.length) {
			$scrollers.each(function(){
				initScrollers( $(this) );
			});
		}

		function responsiveScrollers() {
			if (scrollers.length) {
				$.each(scrollers, function(i, scroller){
					if (typeof scroller !== 'undefined') {
						try {
							scroller.refresh();
							setTimeout(function(){
								if (scroller.scrollerHeight > scroller.wrapperHeight || scroller.scrollerWidth > scroller.wrapperWidth) {
									$(scroller.wrapper).addClass('scroll-enabled');
								}
								else {
									$(scroller.wrapper).removeClass('scroll-enabled');
								}
							}, 10);
						}
						catch(e){}
					}
				});
			}
		}
		window.updateScrollers = responsiveScrollers;

		resizeTasks.push(responsiveScrollers);


		/***************************
		 *
		 *	SWIPER
		 *
		 ***************************/

		function initSwiper( $swipers ) {

			if ( typeof $swipers === 'undefined' ) {
				$swipers = $('.swiper-container');
			}

			if ( !$swipers.length ) {
				return;
			}

			$swipers.each(function(i, container){

				var $sliderContainer = $(container);
				if ( typeof $sliderContainer.data('swiper') !== 'undefined' ) {
					// already init
					return true;
				}

				var $section = $sliderContainer.closest('.section');

				var swiperOptions = {
					spaceBetween: 25,
					autoHeight: false,
					simulateTouch: true,
					allowTouchMove: true,
					resistanceRatio: 0,
					loop: false,
					on: {
						init: function( swiper ){
							if ( $(swiper.$el).find('.swiper-slide-duplicate').length ) {
								lazyLoader.update();
							}
							$(swiper.$wrapperEl).find('[tabindex]').removeAttr('tabindex');
							$.fn.matchHeight._update();
						}
					}
				};

				if ( $sliderContainer.find('.swiper-button-next').length ) {
					swiperOptions = $.extend(true, swiperOptions, {
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev'
						}
					});
				}

				if ( $sliderContainer.find('.swiper-pagination').length ) {
					swiperOptions = $.extend(true, swiperOptions, {
						pagination: {
							el: '.swiper-pagination',
							clickable: true
						}
					});
				}
				else if ( $section.find('.swiper-pagination').length ) {
					// custom pagination outside of swiper-container
					swiperOptions = $.extend(true, swiperOptions, {
						pagination: {
							el:  $section.find('.swiper-pagination').get(0),
							clickable: true
						}
					});
				}

				// custom pagination (page numbers) outside of swiper-container
				if ( $section.find('.swiper-pages').length ) {
					swiperOptions = $.extend(true, swiperOptions, {
						pagination: {
							el: $section.find('.swiper-pages').get(0),
							type: 'fraction'
						}
					});
				}

				// custom nav outside of swiper-container
				if ( $section.find('.swiper-next').length ) {
					swiperOptions = $.extend(true, swiperOptions, {
						navigation: {
							nextEl: $section.find('.swiper-next').get(0),
							prevEl: $section.find('.swiper-prev').get(0)
						}
					});
				}

				if ( $section.hasClass('section--feature-columns') ) {
					swiperOptions = $.extend(true, swiperOptions, {
						simulateTouch: true,
						allowTouchMove: true
					});
				}

				if ( $section.hasClass('section--content-cards-slider') ) {

					swiperOptions = $.extend(true, swiperOptions, {
						autoHeight: false,
						loop: false,
						spaceBetween: halfSpacing,// default to mobile
						slidesPerView: 1,
						breakpoints: {},
						simulateTouch: true,
						allowTouchMove: true,
						speed: 600,
					});

					// when >= mediumBreakpoint (ie when on large)
					swiperOptions.breakpoints[mediumBreakpoint] = {
						slidesPerView: 'auto',
						spaceBetween: baseSpacingUnit,
					};
					// when >= smallBreakpoint (ie when on medium)
					swiperOptions.breakpoints[smallBreakpoint] = {
						spaceBetween: baseSpacingUnit,
						slidesPerView: 2
					};
				}

				if ( $section.hasClass('section--feature-columns') ) {

					swiperOptions = $.extend(true, swiperOptions, {
						spaceBetween: baseSpacingUnit,// default to mobile
						slidesPerGroup: 1,
						slidesPerView: 1,
						watchOverflow: true,
						breakpoints: {},
						simulateTouch: true,
						allowTouchMove: true,
						speed: 600,
					});

					// when >= smallBreakpoint (ie when on medium)
					swiperOptions.breakpoints[smallBreakpoint] = {
						slidesPerGroup: 2,
						slidesPerView: 2
					};

				}

				if ( $section.hasClass('section--reviewr') ) {

					swiperOptions = $.extend(true, swiperOptions, {
						spaceBetween: baseSpacingUnit,// default to mobile
						slidesPerGroup: 1.2,
						slidesPerView: 1.2,
						watchOverflow: true,
						breakpoints: {},
						simulateTouch: true,
						allowTouchMove: true,
						pagination: {
							dynamicBullets: true,
							//dynamicMainBullets: 4,
						},
						speed: 600
					});

					// when >= smallBreakpoint (ie when on medium)
					swiperOptions.breakpoints[smallBreakpoint] = {
						slidesPerGroup: 2,
						slidesPerView: 2,
						spaceBetween: baseSpacingUnit
					};

					// when >= mediumBreakpoint (ie when on large)
					swiperOptions.breakpoints[mediumBreakpoint] = {
						slidesPerGroup: 3,
						slidesPerView: 3,
						spaceBetween: baseSpacingUnit
					};

				}

				if ( $section.hasClass('section--media-slider') ) {
					swiperOptions = $.extend(true, swiperOptions, {
						//simulateTouch: false,
						//allowTouchMove: false,
						centeredSlides: true,
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						loop: false
					});
				}


				var swiper = new Swiper($sliderContainer.get(0), swiperOptions);
				$sliderContainer.data('swiper', swiper);

			});

		}

		initSwiper();

		function responsiveMediaSlider() {
			if ( isSmall ) {
				$('.section--media-slider .swiper-slide .figure--hmax').removeClass('figure--hmax');
			}
			else {
				$('.section--media-slider .swiper-slide .figure:not(.figure--hmax)').addClass('figure--hmax');
			}
		}
		resizeTasks.push( responsiveMediaSlider );


		/***************************
		 *
		 *	CONTENT CARDS SLIDER
		 *
		 ***************************/

		var $cardsSlider = $('.section--content-cards-slider .swiper-container');

		function responsiveCardsSliders() {
			$cardsSlider.each(function(){
				var $slider = $(this);
				var $section = $slider.closest('.section');
				if ( isSmallAndMedium ) {
					$slider.closest('.section__body').addClass('wrap');
					$slider.css({
						"padding-left": '',
						"padding-right": ''
					});
					if ( $section.find('.section__header .swiper-nav').length ) {
						$section.find('.section__header .swiper-nav').detach().appendTo( $section.find('.section__footer') );
					}
				}
				else {
					$slider.closest('.section__body').removeClass('wrap');
					var offset = $slider.closest('.section').find('.section__header').offset().left - $('.page-main').offset().left;
					$slider.css({
						"padding-left": offset+'px',
						"padding-right": offset+'px'
					});
					if ( $section.find('.section__footer .swiper-nav').length ) {
						$section.find('.section__footer .swiper-nav').detach().appendTo( $section.find('.section__header') );
					}
				}

				var slider = $slider.data('swiper');
				if (typeof slider !== 'undefined') {
					slider.update();
				}
			});
		}

		if ( $cardsSlider.length ) {
			resizeTasks.push(responsiveCardsSliders);
		}

		// Keyboard accessibility
		$body.on('focusin', '.section--content-cards-slider .slide__link', function(){
			$(this).closest('.slide').addClass('active');
		});
		$body.on('focusout', '.section--content-cards-slider .slide__link', function(){
			$(this).closest('.slide').removeClass('active');
		});


		/***************************
		 *
		 *	LIGHTCASE
		 *
		 ***************************/

		function initLightcase() {

			$('[data-rel^="lightcase"]').lightcase({
				transition: 'fade',
				transitionOpen: 'fade',
				liveResize: true,
				// width: Math.round(windowWidth * 0.9),
				// height: Math.round(windowHeight * 0.8),
				maxWidth: '90%',
				maxHeight: '80%',
				closeOnOverlayClick: false,
				iframe: {
					// width: Math.round(windowWidth * 0.9),
					// height: Math.round(windowHeight * 0.8)
					allowfullscreen: '',
					allow:'autoplay; encrypted-media',
					modestbranding:'1',
					width: 2560,
					height: 1440
				},
				video: {
					width: Math.round(windowWidth * 0.9),
					height: Math.round(windowHeight * 0.8)
				},
				onStart: {
					pauseSwiperAnimations: function(){
						$('.swiper-container.inview').each(function(){
							var swiper = $(this).data('swiper');
							if (swiper.params.autoplay.enabled) {
								swiper.autoplay.stop();
							}
						});
					}
				},
				onBeforeShow: {
					lightcaseInitSwiper: function(){
						initSwiper();
					}
				},
				onFinish: {
					lightcaseUpdateLazy: function() {
						var $swiper = $('#lightcase-content').find('.swiper-container');
						if ( $swiper.length ) {
							$swiper.data('swiper').update();
						}
						setTimeout(function(){
							lazyLoader.update();
							$.fn.matchHeight._update();
						}, 300);
					}
				},
				onClose: {
					restartSwiperAutoplays: function(){
						$('.swiper-container.inview').each(function(){
							var swiper = $(this).data('swiper');
							if (swiper.params.autoplay.enabled) {
								swiper.autoplay.start();
							}
						});
					}
				}
			});

		}

		initLightcase();

		/***************************
		 *
		 *	STICKY HEADER
		 *
		 ***************************/

		const $header = document.querySelector('.page-header');
		const stickyObserver = new IntersectionObserver(
			([e]) => e.target.classList.toggle("sticky", e.intersectionRatio < 1),
			{ threshold: [1] }
		);
		stickyObserver.observe($header);

		/*
		var $header = $('.page-header');

		function stickyHeaderToogle( scrolled ) {

			var scrolledOver = scrolled > 240;

			var headerOffset = 0 - $header.height() * 3;
			var transitionDuration = 300;

			var hasAdminBar = $body.hasClass('admin-bar');
			var offsetBuffer = ( hasAdminBar ) ? $('#wpadminbar').outerHeight() : 0;
			headerOffset += offsetBuffer;

			var announcementOffset = ( $('.announcement-bar').length ) ? $('.announcement-bar').outerHeight() : 0;

			if ( isMedium ) {
				$header.stop().css({
					"position": "",
					"top": ""
				}).addClass('sticky sticky-in');
			}
			else {

				if ( scrolledOver && !$header.hasClass('sticky-in') ) {
					$header.stop().css({
						"position": "fixed",
						"top": headerOffset+"px"
					}).addClass('sticky').animate({ top: offsetBuffer }, transitionDuration, function(){
						$header.addClass('sticky-in');
					});
				}
				else if ( !scrolledOver && $header.hasClass('sticky') ) {
					$header.stop().removeClass('sticky-in').animate({ top: headerOffset+"px" }, transitionDuration, function(){
						$header.removeClass('sticky').css({
							"position": "absolute",
							"top": headerOffset+"px"
						}).animate({ top: offsetBuffer + announcementOffset }, transitionDuration);
					});
				}

			}

		}

		scrollTasks.push(stickyHeaderToogle);
		*/

		/***************************
		 *
		 *	MENU PANEL
		 *
		 ***************************/

		var $headerNav = $('.page-header nav');
		var $menuPanel = $('.menu-panel');
		var $menuPanelBg = $('.menu-panel__bg');
		var $menuPanelTriggerLink;// used for restoring focus to same item in header when panel closes (if keyboard navigation used)

		// menu panel white background section
		function responsiveMenuPanel() {
			var offset = $('.page-header .wrap').offset().left;
			if ( offset === 0 ) {
				offset = doubleSpacing;
			}
			$menuPanelBg.width( offset + 320 );
			$menuPanel.find('.nav:not(.sub-menu) > li.menu-item-has-children > .sub-menu').css({ left: offset+'px' });

			if ( !isLarge && $html.hasClass('menu-open') ) {
				$('.menu-panel__close').click();
			}

		}
		$window.on('resize', responsiveMenuPanel);

		// setup matchHeight on connected submenus in overlay
		/*
		$menuPanel.find('nav a[data-content_id]').each(function(){
			var $this = $(this);

			var selectors = [];

			var $parent = $this.parent();
			var subSelector = $parent.data('target');
			if ( typeof subSelector !== 'undefined' && subSelector !== '' ) {
				selectors.push( subSelector );
				$( subSelector ).find('li').each(function(){
					var childSubSelector = $(this).data('target');
					if ( typeof childSubSelector !== 'undefined' && childSubSelector !== '' ) {
						selectors.push( childSubSelector );
					}
				});
			}

			if (selectors.length) {
				//selectors.push('.menu-panel__submenu, .menu-panel__child-submenu');
				selectors.push('.menu-panel__submenu');
				$( selectors.join(', ') ).matchHeight();
			}
		});
		*/

		// on click for any top level menu (in page-header and menu-panel)
		$body.on('click', 'nav > .nav > li.menu-item-has-children > a', function( e){
			e.preventDefault();

			$html.addClass('menu-open');

			$menuPanel.css('display', 'flex').attr('aria-hidden', 'false');
			setTimeout(function(){
				$.fn.matchHeight._update();
				$menuPanel.addClass('active');
			}, 10);

			var $link = $(this);
			var $parent = $link.parent();
			var subSelector = $parent.data('target');
			var $targetSub = $(subSelector);

			var keyboardFocused = $link.hasClass("focus-visible");

			if ( $targetSub.length ) {

				$menuPanelTriggerLink = ( keyboardFocused ) ? $link : undefined;

				var $menuPanelTargetItem = $menuPanel.find('li[data-target="' + $parent.data('target') + '"]');
				$menuPanelTargetItem.addClass('active').siblings('li').removeClass('active');// adds 'active' to header AND overlay top-level links

				// Accessibility
				$link.attr('aria-expanded', 'true');
				$menuPanelTargetItem.siblings('li').find('> a').attr('aria-expanded', 'false');
				$menuPanelTargetItem.find('> a').attr('aria-expanded', 'true');

				//$targetSub.siblings('.sub-menu').hide().removeClass('active');
				$targetSub.siblings('.sub-menu').removeClass('active');
				setTimeout(function(){
					$targetSub.siblings('.sub-menu').hide();
				}, 1000);

				if ( $targetSub.find('li:first > .child-submenu').length ) {
					// if the item has a child submenu, trigger click on the item to reveal it on open
					$targetSub.find('li:first > a').click();
				}
				else {
					// add the no-child-submenu class
					$menuPanel.find('.menu-panel__submenu').addClass('no-child-submenu');
				}

				$targetSub.show();
				setTimeout(function(){
					$targetSub.addClass('active');
					// Keyboard accessibility
					if ( keyboardFocused ) {
						$targetSub.find('li:first > a').focus();// move focus from header menu to first item in sub menu
					}
				}, 10);

				var contentID = $link.data('content_id');
				if ( typeof contentID !== 'undefined' && contentID !== '' ) {
					var $targetContent = $('#menu_content_' + contentID);
					if ( $targetContent.length ) {
						//$targetContent.siblings().hide().removeClass('active');
						$targetContent.siblings().removeClass('active');
						setTimeout(function(){
							$targetContent.siblings().hide();
						}, 1000);

						$targetContent.show();
						setTimeout(function(){
							$targetContent.addClass('active');
						}, 10);
					}
				}
			}
		});

		// on sub-menu link click in menu-panel
		$body.on('click', '.menu-panel .sub-menu:not(.child-submenu) > li.menu-item-has-children > a', function( e){
			e.preventDefault();
			var $this = $(this);
			var $parent = $this.parent();

			$parent.siblings('li').removeClass('active');
			$parent.siblings('li').find('> a').attr('aria-expanded', 'false');

			$parent.addClass('active');
			$this.attr('aria-expanded', 'true');

			var childSubSelector = $parent.data('target');
			var $targetChildSub = $(childSubSelector);

			if ( $targetChildSub.length ) {

				//$menuPanel.find('.child-submenu.active').hide().removeClass('active');
				$menuPanel.find('.child-submenu.active').removeClass('active');
				setTimeout(function(){
					$menuPanel.find('.child-submenu:not(.active)').hide();
				}, 1000);

				$targetChildSub.show();
				setTimeout(function(){
					$targetChildSub.addClass('active');
					// remove the no-child-submenu class
					$menuPanel.find('.menu-panel__submenu').removeClass('no-child-submenu');
				}, 10);

				// Keyboard accessibliity
				//$targetChildSub.find('li:first > a').focus();
			}
			else {
				// add the no-child-submenu class
				$menuPanel.find('.menu-panel__submenu').addClass('no-child-submenu');
			}
		});

		// menu panel close
		$body.on('click', '.menu-panel__close', function( e){
			e.preventDefault();

			$html.removeClass('menu-open');

			$menuPanel.removeClass('active');
			setTimeout(function(){
				$menuPanel.hide().attr('aria-hidden', 'true');
			}, 1000);

			$headerNav.find('li.active').removeClass('active').find('> a').attr('aria-expanded', 'false');
			$menuPanel.find('.sub-menu.active, .menu-panel__content-block.active').removeClass('active');
			$menuPanel.find('.nav li.active').removeClass('active').find('> a').attr('aria-expanded', 'false');

			// Keyboard accessibliity
			if ( typeof $menuPanelTriggerLink !== 'undefined' && $menuPanelTriggerLink.length && $menuPanelTriggerLink.closest('.page-header').length ) {
				$menuPanelTriggerLink.focus();// switch focus back to main menu item that opened the panel
			}
		});

		// any menu link without submenu
		$body.on('click', '.nav[id^="menu-main-menu"] li:not(.menu-item-has-children) > a', function(){
			$('.menu-panel__close').click();
		});

		// Keyboard accessibliity
		$doc.on('keyup', function(e){
			if ( e.key === "Escape" && $html.hasClass('menu-open') ) {
				$('.menu-panel__close').click();
			}
		});

		/***************************
		 *
		 *	MOBILE MENU
		 *
		 ***************************/

		var $mobileMenu = $('#mobile_menu');

		var $mobileMenuPrimaryPanel = $mobileMenu.find('.modal__panel--primary');
		var $mobileMenuSecondaryPanel = $mobileMenu.find('.modal__panel--secondary');
		var $mobileMenuTertiaryPanel = $mobileMenu.find('.modal__panel--tertiary');

		var $mobileMenuPrimaryHeader = $mobileMenuPrimaryPanel.find('.modal__panel-header');
		var $mobileMenuPrimaryFooter = $mobileMenuPrimaryPanel.find('.modal__panel-footer');
		var $mobileMenuPrimaryBody = $mobileMenuPrimaryPanel.find('.modal__panel-body');

		var $mobileMenuSecondaryHeader = $mobileMenuSecondaryPanel.find('.modal__panel-header');
		var $mobileMenuSecondaryBody = $mobileMenuSecondaryPanel.find('.modal__panel-body');
		var $mobileMenuSecondaryTitle = $mobileMenuSecondaryPanel.find('.modal__panel-title');

		var $mobileMenuTertiaryHeader = $mobileMenuTertiaryPanel.find('.modal__panel-header');
		var $mobileMenuTertiaryBody = $mobileMenuTertiaryPanel.find('.modal__panel-body');
		var $mobileMenuTertiaryTitle = $mobileMenuTertiaryPanel.find('.modal__panel-title');

		function responsiveMobileMenu() {
			var availablePrimaryHeight = $mobileMenuPrimaryPanel.outerHeight() - ( $mobileMenuPrimaryHeader.outerHeight() + $mobileMenuPrimaryFooter.outerHeight() );
			var availableSecondaryHeight = $mobileMenuSecondaryPanel.outerHeight() - $mobileMenuSecondaryHeader.outerHeight();
			var availableTertiaryHeight = $mobileMenuTertiaryPanel.outerHeight() - $mobileMenuTertiaryHeader.outerHeight();

			if ( !isMedium ) {
				$mobileMenuPrimaryBody.outerHeight(availablePrimaryHeight);
			}
			else {
				$mobileMenuPrimaryBody.css('height', '');
			}

			$mobileMenuSecondaryBody.outerHeight(availableSecondaryHeight);
			$mobileMenuTertiaryBody.outerHeight(availableTertiaryHeight);

			responsiveScrollers();

			if ( isLarge && $('#mobile_menu').hasClass('modal--open') ) {
				$('#mobile_menu .modal__close').click();
			}

		}

		resizeTasks.push(responsiveMobileMenu);

		$body.on('click', '#mobile_menu .modal__panel--primary nav > .nav > li.menu-item-has-children > a', function(e){
			e.preventDefault();
			var $link = $(this);
			var $subNav = $link.nextAll('.nav:first');
			if ($subNav.length) {
				//$logo.addClass('hidden');
				var $secondaryNav = $mobileMenuSecondaryBody.find('> nav');
				$secondaryNav.empty();
				$subNav.clone().appendTo($secondaryNav);
				$mobileMenuSecondaryTitle.html( $link.html() );
				responsiveMobileMenu();
				$mobileMenuPrimaryPanel.removeClass('active');
				$mobileMenuSecondaryPanel.addClass('active');
			}
		});

		$body.on('click', '#mobile_menu .modal__panel--secondary .modal__back', function(e){
			e.preventDefault();
			//$logo.removeClass('hidden');
			$mobileMenuSecondaryPanel.removeClass('active');
			$mobileMenuPrimaryPanel.addClass('active');
		});

		$body.on('click', '#mobile_menu .modal__panel--secondary nav > .nav > li.menu-item-has-children > a', function(e){
			e.preventDefault();
			var $link = $(this);
			var $subNav = $link.nextAll('.nav:first');
			if ($subNav.length) {
				var $tertiaryNav = $mobileMenuTertiaryBody.find('> nav');
				$tertiaryNav.empty();
				$subNav.clone().appendTo($tertiaryNav);
				var panelTitle = $link.html() + ' ' + $link.closest('.modal__panel').find('.modal__panel-title').html();
				$mobileMenuTertiaryTitle.html( panelTitle );
				responsiveMobileMenu();
				$mobileMenuSecondaryPanel.removeClass('active');
				$mobileMenuTertiaryPanel.addClass('active');
			}
			return false;
		});

		$body.on('click', '#mobile_menu .modal__panel--tertiary .modal__back', function(e){
			e.preventDefault();
			$mobileMenuTertiaryPanel.removeClass('active');
			$mobileMenuSecondaryPanel.addClass('active');
		});


		/***************************
		 *
		 *	MODAL
		 *
		 ***************************/

		function closeModal() {
			$('.modal.modal--open').removeClass('modal--open').attr('aria-hidden', 'true');
			$html.removeClass('modal-open menu-open');
			//$logo.removeClass('hidden');
		}

		function openModal(selector) {
			var $target = $(selector);
			if ($target.length && $target.hasClass('modal')) {
				closeModal();// close any open ones first
				$html.addClass('modal-open');
				$target.addClass('modal--open').attr('aria-hidden', 'false');
			}
		}

		$body.on('click', '.modal__close', function(e){
			e.preventDefault();
			closeModal();
		});

		$body.on('click', 'a[href^="#"]', function(e){
			var $trigger = $(this);
			var targetSelector = $trigger.attr('href');
			var $target = $(targetSelector);
			if ($target.length && $target.hasClass('modal')) {
				e.preventDefault();
				openModal(targetSelector);
			}
		});



		/***************************
		 *
		 *	CONTENT TRANSITIONS
		 *
		 ***************************/

		var $ctItems = $('[data-ct]');
		var ct_defaultOffset = 100;
		var ct_defaultDelay = 1;

		if ($ctItems.length && !isTouchDevice) {

			$ctItems.each(function(){
				var $item = $(this);
				var $section = $item.closest('.section');
				var delay = $item.data('ct-delay');
				if (typeof delay !== 'undefined' && delay !== '') {
					delay = parseFloat(delay) / 1000;
					$item.css('transition-delay', delay+'s');
				}

				if (!$section.is(':first-child')) {
					$item.addClass('ct-init');
				}
				else {
					$item.removeAttr('data-ct');
				}
			});

			$ctItems.on('inview', function(event, isInView){
				if (isInView) {
					$(this).addClass('ct-in');
				}
			});

		}


		/***************************
		 *
		 *	A-Z
		 *
		 ***************************/

		$body.on('click', '.a-z button', function(e){
			e.preventDefault();

			var $btn = $(this);
			var $section = $btn.closest('.section');

			if ( $btn.hasClass('active') ) {
				$btn.removeClass('active');
				$section.find('.grid__item[data-ref]').show();
			}
			else {
				$btn.siblings().removeClass('active');
				$btn.addClass('active');
				$section.find('.grid__item[data-ref]').hide();
				$section.find('.grid__item[data-ref="' + $btn.data('ref') + '"]').show();
			}

		});


		/***************************
		 *
		 *	ACCORDION
		 *
		 ***************************/

		function toggleAccordion(targetSelector, forceOpen) {
			var $target = $(targetSelector);
			if ( !$target.length ) {
				return;
			}

			var $accordion = $target.closest('.accordion');
			var singleOnly = $accordion.hasClass('accordion--single-opens');

			var $trigger = $('.accordion__trigger[href="#' + $target.attr('id') + '"]');
			var $item = $trigger.closest('.accordion__item');
			if ($item.hasClass('open') && forceOpen !== true) {
				// close it
				$trigger.attr('aria-expanded', 'false');
				$item.removeClass('open').addClass('closed');
				$item.find('.accordion__body').slideUp();
			}
			else {
				if (singleOnly) {
					$accordion.find('.accordion__item.open').each(function(){
						var $openAccordion = $(this);
						$openAccordion.find('.accordion__trigger').attr('aria-expanded', 'false');
						$openAccordion.find('.accordion__body').slideUp();
						$openAccordion.addClass('closed').removeClass('open');
					});
				}
				$trigger.attr('aria-expanded', 'true');
				$item.addClass('open').removeClass('closed');
				$item.find('.accordion__body').slideDown(function(){

					$item.find('.swiper-container').each(function(){
						var swiper = $(this).data('swiper');
						if ( typeof swiper !== 'undefined' ) {
							swiper.update();
						}
					});
					lazyLoader.update();
					$.fn.matchHeight._update();
					initLightcase();

				});
			}
		}

		$body.on('click', '.accordion__trigger', function(e) {
			e.preventDefault();
			var $trigger = $(this);
			toggleAccordion( $trigger.attr('href') );
			return false;
		});

		var $accordionSections = $('.section--accordion');
		if ($accordionSections.length) {

			$accordionSections.each(function(){
				var $section = $(this);
				if ( $section.find('.accordion--single-opens').length ) {
					$section.find('.accordion__item.open').not(':first').find('.accordion__trigger').click();
				}
			});

		}


		/***************************
		 *
		 *	REVIEWR
		 *
		 ***************************/
		var $reviewrSections = $('.section--reviewr.loading');

		function loadReviewrReviews() {
			if ( ! $reviewrSections.length ) {
				return false;
			}

			$reviewrSections.each(function(){
				var $section = $(this);

				var feed = $section.data('feed');
				if (typeof feed === 'undefined' ) {
					feed = "";
				}

				var type = $section.data('type');
				if (typeof type === 'undefined' ) {
					type = "";
				}

				var suburb = $section.data('suburb');
				if (typeof suburb === 'undefined' ) {
					suburb = "";
				}

				var state = $section.data('state');
				if (typeof state === 'undefined' ) {
					state = "";
				}

				$.ajax({
					type: "POST",
					data: {
						action: 'reviews_feed',
						feed,
						state,
						suburb,
						type,
					},
					url: window.global_vars.ajax_url,
					complete: function(){
						$section.removeClass('loading');
					},
					success: function(result){
						$section.find('.section__body').html(result);
						initSwiper( $section.find('.swiper-container') );
						lazyLoader.update();
					},
					error: function(jqXHR, textStatus, errorThrown) {
						//$section.remove();
					}
				});

			});

		}

		if ($reviewrSections.length) {
			loadTasks.push(loadReviewrReviews);
		}


		/***************************
		 *
		 *	GOOGLE REVIEWS
		 *
		 ***************************/
		var $googleReviewsSections = $('.section--google-reviews');

		function loadGoogleReviews() {
			if (!$googleReviewsSections.length) {
				return false;
			}

			$googleReviewsSections.each(function(){
				var $section = $(this);

				var location = $section.data('location');
				if (typeof location === 'undefined' || location === '') {
					return true;
				}

				$.ajax({
					type: "POST",
					data: {
						action: 'google_business_reviews',
						location: location
					},
					url: window.global_vars.ajax_url,
					complete: function(){
						$section.removeClass('loading');
					},
					success: function(result){
						$section.find('.section__body').html(result);
						setTimeout(function(){
							initSwiper( $section.find('.swiper-container') );
						}, 100);
					},
					error: function(jqXHR, textStatus, errorThrown) {
						//$section.remove();
					}
				});

			});

		}

		if ($googleReviewsSections.length) {
			loadTasks.push(loadGoogleReviews);
		}


		/***************************
		 *
		 *	 CONTENT CARDS GRID
		 *
		 ***************************/

		// Keyboard accessibility
		$body.on('focusin', '.section--content-cards-grid .item__link', function(){
			$(this).closest('.item').addClass('active');
		});
		$body.on('focusout', '.section--content-cards-grid .item__link', function(){
			$(this).closest('.item').removeClass('active');
		});

		/***************************
		 *
		 *	 FEATURE COLUMNS
		 *
		 ***************************/

		// Keyboard accessibility
		$body.on('focusin', '.section--feature-columns .item__link', function(){
			$(this).closest('.item').addClass('active');
		});
		$body.on('focusout', '.section--feature-columns .item__link', function(){
			$(this).closest('.item').removeClass('active');
		});


		/***************************
		 *
		 *	LINKS DROPDOWN
		 *
		 ***************************/

		var $linksDropdown = $('.links-dropdown');
		var linksDropdownOpen = false;

		function onLinksDropdownEscapeListen(e) {
			if ( linksDropdownOpen && e.key === "Escape" ) {
				$linksDropdown.find('.links-dropdown__title').click();
			}
		}

		if ( $linksDropdown.length ) {

			$linksDropdown.find('button, li, a').on('focusin', function(){
				$doc.on('keyup', onLinksDropdownEscapeListen);
			});
			$linksDropdown.find('button, li, a').on('focusout', function(){
				$doc.off('keyup', onLinksDropdownEscapeListen);
			});

			$linksDropdown.find('.links-dropdown__title').on('click', function(e){
				var $trigger = $(this);
				var $dropdown = $trigger.closest('.links-dropdown');
				var $list = $dropdown.find('.links-dropdown__list');
				if ( $dropdown.hasClass('active') ) {
					linksDropdownOpen = false;
					$dropdown.removeClass('active');
					$trigger.attr('aria-expanded', 'false');
					$dropdown.find('li').css('opacity', 0);
					$list.slideUp('fast');
				}
				else {
					linksDropdownOpen = true;
					$dropdown.addClass('active');
					$trigger.attr('aria-expanded', 'true');
					$list.slideDown('fast', function(){
						$dropdown.find('li').css('opacity', 1);
					});
				}
			});

		}


		/***************************
		 *
		 *	GOOGLE MAPS
		 *
		 ***************************/

		var googleMapsLoad = false;
		var googleMapsIsReady = false;
		var googleMapsApiReadyCallbacks = [];


		window.customInitGfGeo = function() {
			console.log('TMG::customInitGfGeo', window._getTimeSinceStart());
			if ( typeof window.GF_Geo !== 'undefined' ) {
				$('.gform_wrapper').each(function(){
					var $formWrapper = $(this);
					var $formPage = $formWrapper.find('.gform_page:visible');
					var form_id = parseInt( $formWrapper.attr('id').replace('gform_wrapper_', ''), 10 );
					var page_number = ( $formPage.length ) ? parseInt( $formPage.attr('id').replace('gform_page_' + form_id + '_', ''), 10 ) : undefined;
					GF_Geo.init( form_id, page_number );
					console.log('TMG::GF_Geo.init', window._getTimeSinceStart());
				});
			}
		};
		googleMapsApiReadyCallbacks.push('customInitGfGeo', window._getTimeSinceStart());

		window.onGoogleMapsApiReady = function(){
			console.log('TMG::onGoogleMapsApiReady');
			googleMapsIsReady = true;
			$.each(googleMapsApiReadyCallbacks, function(i, callback){
				if ( typeof window[callback] === 'function' ) {
					window[callback]();
				}
			});
		};

		function loadGoogleMapsApi(callbackName) {
			console.log('TMG::loadGoogleMapsApi', window._getTimeSinceStart());

			callbackName = callbackName || '';
			if (callbackName !== '' && window.hasOwnProperty(callbackName) && typeof window[callbackName] === 'function') {
				googleMapsApiReadyCallbacks.push(callbackName);
			}

			if (!googleMapsLoad) {
				googleMapsLoad = true;
				// load maps API
				var gmapsKey = (window.global_vars.hasOwnProperty('gmaps_key')) ? window.global_vars.gmaps_key : '';
				var gmapsRegion = (window.global_vars.hasOwnProperty('country')) ? window.global_vars.country.toUpperCase() : 'AU';
				var script = document.createElement('script');
				script.type = 'text/javascript';
				script.async = true;
				script.defer = true;
				script.src = 'https://maps.googleapis.com/maps/api/js?key='+gmapsKey+'&libraries=places,geometry&region='+gmapsRegion+'&callback=onGoogleMapsApiReady';
				document.body.appendChild( script );
			}

		}

		/***************************
		 *
		 *	SUBURB SEARCH
		 *
		 ***************************/

		var $suburbSearchForm = (isSmall || isMedium) ? $('#suburb_search_form_mobile') : $('#suburb_search_form');
		var $suburbSearchInput = (isSmall || isMedium) ? $('#suburb_search_input_mobile') : $('#suburb_search_input');
		var $suburbSearchMessage = (isSmall || isMedium) ? $('#suburb_search_message_mobile') : $('#suburb_search_message');

		var suburbSearchAutocomplete;
		var suburbSearchAutocompletePlace = false;
		var suburbSearchAutocompleteSearchOptionsRegions = "AU";
		var suburbSearchAutocompleteSearchOptions = {
			//types: ['(cities)'],
			types: ['(regions)'],
			componentRestrictions: { country: suburbSearchAutocompleteSearchOptionsRegions }
		};

		function onSuburbSearchAutocompletePlaceChanged() {

			if ( !$suburbSearchForm.length ) {
				suburbSearchAutocompletePlace = false;
				return;
			}

			$suburbSearchForm.removeClass('error');
			$suburbSearchMessage.empty();
			$suburbSearchForm.addClass('waiting');

			var searchTerm = $suburbSearchInput.val();
			suburbSearchAutocompletePlace = ( $.trim( searchTerm ) !== '' ) ? suburbSearchAutocomplete.getPlace() : false;

			if (suburbSearchAutocompletePlace) {
				$suburbSearchForm.submit();
			}

		}

		function initSuburbSearchAutocomplete() {

			suburbSearchAutocomplete = new google.maps.places.Autocomplete( $suburbSearchInput.get(0), suburbSearchAutocompleteSearchOptions );
			suburbSearchAutocomplete.inputName = $suburbSearchInput.attr('name');
			suburbSearchAutocomplete.addListener('place_changed', onSuburbSearchAutocompletePlaceChanged);

			/*
			setTimeout(function(){
				$('body > .pac-container:last').detach().appendTo( $suburbSearchInput.parent() );
			}, 500);
			*/

		}
		window.initSuburbSearchAutocomplete = initSuburbSearchAutocomplete;

		if ( $suburbSearchForm.length ) {

			/*
			$suburbSearchInput.on('click', function(e){
				$(this).removeClass('focus-visible');
			});
			*/

			$suburbSearchForm.on('submit', function(e){
				e.preventDefault();

				if ( !suburbSearchAutocompletePlace ) {
					suburbSearchAutocompletePlace = false;
					$suburbSearchForm.removeClass('waiting');
					return false;
				}

				var searchData = {
					action: "location_search",
					postcode: "",
					suburb: "",
				};

				$.each(suburbSearchAutocompletePlace.address_components, function(i, component){
					if ( $.inArray("postal_code", component.types) !== -1 ) {
						searchData.postcode = component.long_name;
					}
					else if ( $.inArray("locality", component.types) !== -1 ) {
						searchData.suburb = component.long_name;
					}
				});

				if ( searchData.postcode === "" && searchData.suburb === "" ) {
					$suburbSearchMessage.html( "Enter a suburb or postcode" );
					$suburbSearchForm.removeClass('waiting').addClass('error');
					return false;
				}

				$.ajax({
					type: "POST",
					data: searchData,
					url: window.global_vars.ajax_url,
					success: function(result){
						var $currentStateLink = $('.menu-panel__body .sub-menu:visible > li.active > a');
						var browseLinkUrl = ( $currentStateLink.length ) ? $currentStateLink.attr('href') : window.global_vars.home + '/locations/';
						var fallbackUrl = ( window.global_vars.suburb_search_fallback_url !== '' ) ? window.global_vars.suburb_search_fallback_url : '';

						if ( fallbackUrl !== '' ) {
							if ( searchData.suburb !== "" && searchData.postcode !== "" ) {
								fallbackUrl += "?loc=" + encodeURIComponent(searchData.suburb + ', ' + searchData.postcode);
							}
							else if ( searchData.suburb !== "" ) {
								fallbackUrl += "?loc=" + encodeURIComponent(searchData.suburb);
							}
							else if ( searchData.postcode !== "" ) {
								fallbackUrl += "?loc=" + encodeURIComponent(searchData.postcode);
							}
						}

						var browseLinkHTML = '<a href="' + browseLinkUrl + '">Browse locations</a>';

						if ( result.success ) {
							var url = ( result.hasOwnProperty('data') && result.data.hasOwnProperty('url') && result.data.url !== "" ) ? result.data.url : "";
							if ( url !== "" ) {
								transitionToNewPage( result.data.url );
							}
							else if ( fallbackUrl !== '' ) {
								transitionToNewPage( fallbackUrl );
							}
							else {
								$suburbSearchMessage.html( "No results found. " + browseLinkHTML );
								$suburbSearchForm.removeClass('waiting').addClass('error');
							}
						}
						else if ( fallbackUrl !== '' ) {
							transitionToNewPage( fallbackUrl );
						}
						else {
							var msg = ( result.hasOwnProperty('data') && result.data.hasOwnProperty('message') && result.data.message !== "" ) ? result.data.message : "No results found.";
							if ( msg.indexOf("required") === -1 ) {
								msg += " " + browseLinkHTML;
							}
							$suburbSearchMessage.html( msg );
							$suburbSearchForm.removeClass('waiting').addClass('error');
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						$suburbSearchMessage.html( textStatus );
						$suburbSearchForm.removeClass('waiting').addClass('error');
					}
				});

			});

			loadGoogleMapsApi( "initSuburbSearchAutocomplete" );

		}
		else {

			loadGoogleMapsApi();

		}


		/***************************
		 *
		 *	STATES / REGIONS BUTTONS
		 *
		 ***************************/

		$('.section--state-regions-buttons .parent-group a').on('click', function(e){
			var $btn = $(this);
			if ( $btn.hasClass('active') ) {
				return false;
			}
			var $section = $btn.closest('.section');
			var $childGroup = $section.find('.child-group[data-parent="' + $btn.data('id') + '"]');
			if ( $childGroup.length ) {
				e.preventDefault();
				$section.find('.parent-group a.active, .child-group.active').removeClass('active');
				$btn.addClass('active');
				$childGroup.addClass('active');
			}
		});


		/***************************
		 *
		 *	SCROLL TO
		 *
		 ***************************/

		$body.on('click', 'a[href^="#"]', function(e){
			var $this = $(this);
			var href = $this.attr('href');
			var sel = href.substring(href.indexOf('#'));
			var $target = $(sel);

			if ( !$this.parent().hasClass('menu-item-has-children') ) {

				if (href === '#') {
					e.preventDefault();
					return false;
				}
				if (href !== "#main" && $target.length && !$target.hasClass('menu-panel') && !$target.hasClass('modal') && !$target.hasClass('accordion__body')) {
					e.preventDefault();
					scrollTo($target);
				}

			}
		});

		function hashScroll() {
			if (window.location.hash !== '' && window.location.hash !== '#') {
				var $hashScrollTarget = $(window.location.hash);
				if ($hashScrollTarget.length) {
					if ($hashScrollTarget.hasClass('modal')) {
						openModal(window.location.hash);
					}
					else {
						if ($hashScrollTarget.hasClass('accordion__body')) {
							toggleAccordion(window.location.hash, true);
						}
						scrollTo($hashScrollTarget);
					}
				}
			}
		}

		loadTasks.push(hashScroll);


		/***************************
		 *
		 *	SHARING
		 *
		 ***************************/

		$body.on('click', '.sharing a', function(e){
			e.preventDefault();
			var $this = $(this);
			var title = $this.attr('title');
			var url = $this.attr('href');
			Utils.centeredPopup(url, 'Share via ' + title + '', 450, 450);
		});

		/***************************
		 *
		 *	TRANSITION IN / OUT
		 *
		 ***************************/

		/*
		var siteLinkBase = window.location.protocol + '//' + window.location.host;
		var siteLinkSelector = 'a[href^="'+siteLinkBase+'"]:not([target="_blank"]):not([data-rel^="lightcase"])';
		$body.on('click', siteLinkSelector, function(e){
			var $link = $(this);
			e.preventDefault();

			//if ($link.closest('#mobile_menu, .menu-panel__submenu').length && $link.parent().hasClass('menu-item-has-children')) {
			if ( $link.parent().hasClass('menu-item-has-children') ) {
				return false;
			}

			var url = $link.attr('href');
			transitionToNewPage( url );
		});
		*/

		$body.on('click', 'li.menu-item-has-children > a', function(e){
			return false;
		});



		/***************************
		 *
		 *	RESPONSIVE CALLBACK LINKS
		 *
		 ***************************/

		var $callbackLinks = $('a[href$="#request_callback"]');
		var dayIndexLookup = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		var freeQuotePage = window.global_vars.free_quote_url;

		window.isOpenNow = function(){
			var d = window.serverTime();
			var day = dayIndexLookup[ d.getDay() ];
			if ( !window.global_vars.hasOwnProperty('business_hours') || !window.global_vars.business_hours || !window.global_vars.business_hours.hasOwnProperty(day) || !window.global_vars.business_hours[day].hasOwnProperty('start') || !window.global_vars.business_hours[day].hasOwnProperty('end') ) {
				return true;
			}
			var isOpenToday = ( window.global_vars.business_hours[day].hasOwnProperty('open') ) ? window.global_vars.business_hours[day].open : true;
			if ( !isOpenToday ) {
				return false;
			}
			var openHoursStart = ( isOpenToday && window.global_vars.business_hours[day].start !== '' ) ? parseInt( window.global_vars.business_hours[day].start.split(':')[0], 10) : 0;
			var openHoursEnd = ( isOpenToday && window.global_vars.business_hours[day].end !== '' ) ? parseInt( window.global_vars.business_hours[day].end.split(':')[0], 10) : 24;
			var openMinStart = ( isOpenToday && window.global_vars.business_hours[day].start !== '' ) ? parseInt( window.global_vars.business_hours[day].start.split(':')[1], 10) : 0;
			var openMinEnd = ( isOpenToday && window.global_vars.business_hours[day].end !== '' ) ? parseInt( window.global_vars.business_hours[day].end.split(':')[1], 10) : 60;
			if ( openHoursStart < d.getHours() && openHoursEnd > d.getHours() ) {
				return true;
			}
			if ( ( openHoursStart === d.getHours() && openMinStart < d.getMinutes() ) || ( openHoursEnd === d.getHours() && openMinEnd > d.getMinutes() ) ) {
				return true;
			}
			return false;
		};

		function responsiveCallbackLinks() {
			var isOpenNow = window.isOpenNow();
			$callbackLinks.each(function(){
				var $link = $(this);
				if ( isSmall && isOpenNow ) {
					$link.html( window.global_vars.strings.call_us_now ).attr('href', 'tel:' + window.global_vars.phone_clean);
				}
				else {
					//$link.html( unescape( $link.data('label') ) ).attr('href', '#request_callback');
					$link.html( decodeURI( $link.data('label') ) ).attr('href', freeQuotePage);
				}
			});
		}

		if ( $callbackLinks.length ) {
			$callbackLinks.each(function(){
				var $link = $(this);
				$link.data( 'label', encodeURI( $link.text() ) );
			});
			resizeTasks.push(responsiveCallbackLinks);
		}


		/***************************
		 *
		 *	SCROLL
		 *
		 ***************************/

		var lastScrolledAmount = 0;

		function onWindowScroll() {
			var scrolled = window.scrollY;
			if ( scrolled > lastScrolledAmount ) {
				scrollDirection = "down";
			}
			else if ( scrolled < lastScrolledAmount ) {
				scrollDirection = "up";
			}
			else {
				scrollDirection = "";
			}

			lastScrolledAmount = scrolled;

			//var scrolledOver = (isSmall) ? (scrolled > 10) : (scrolled > windowHeight);
			var scrolledOver = scrolled > 120;
			$html.toggleClass('scrolled', scrolledOver);
			$.each(scrollTasks, function(i, func){
				func(scrolled);
			});
		}

		$window.on('scroll', onWindowScroll);


		/***************************
		 *
		 *	RESPONSIVE / BREAKPOINTS
		 *
		 ***************************/

		function onWindowResize() {

			responsiveSizes();

			$.each(resizeTasks, function(i, func){
				if (Utils.isFunction(func)) {
					func();
				}
			});

		}
		window.onWindowResize = onWindowResize;

		$window.on('resize', Utils.debounce(onWindowResize, 50));

		$window.trigger('resize');
		$window.trigger('scroll');

		var windowLoaded = false;
		var loadTasksProcessed = false;

		function processLoadTasks() {
			if (!loadTasksProcessed) {
				$.each(loadTasks, function(i, func){
					func();
				});
				loadTasksProcessed = true;
			}
		}

		function onWindowLoaded() {
			$html.removeClass('loading');
			setTimeout(function(){
				processLoadTasks();
				onWindowResize();
			}, 500);
		}

		setTimeout(function(){
			if (!windowLoaded) {
				onWindowLoaded();
			}
		}, 3000);

		$window.on('load', function(){
			onWindowResize();
			windowLoaded = true;
			onWindowLoaded();
		});

		$window.on("pageshow", function(event) {
			if (event.originalEvent.persisted) {
				onWindowResize();
				windowLoaded = true;
				onWindowLoaded();
			}
		});

	});

})(jQuery);
